import { FETCH_COUNTRIES } from "../../constants/country";
import { feeds } from "../../apis/services";

export const fetchCountries = () => {
  return {
    type: FETCH_COUNTRIES,
    payload: feeds.getCountries(),
  };
};
